import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Textarea } from '@criteria-labs/react';
import { useRequestDescriptor } from '../request-view/useRequest';
import { ContentTypePicker } from './ContentTypePicker';
export function RequestBody() {
    var _a, _b, _c, _d;
    const [request, { setHeader, setBody }] = useRequestDescriptor();
    const contentTypes = (_b = (_a = request.resourceConfiguration) === null || _a === void 0 ? void 0 : _a.supportedMediaTypes) !== null && _b !== void 0 ? _b : [];
    const headers = new Headers((_c = request.headers) !== null && _c !== void 0 ? _c : {});
    const selectedContentType = (_d = headers.get('Content-Type')) !== null && _d !== void 0 ? _d : (contentTypes.length > 0 ? contentTypes[0] : null);
    return (_jsxs("div", { className: "space-y-2 p-2", children: [_jsx(ContentTypePicker, { contentTypes: contentTypes, selectedContentType: selectedContentType, onChange: (contentType) => {
                    setHeader('Content-Type', contentType);
                } }), _jsx(Textarea, { name: "body", id: "body", className: "font-mono text-xs [&>input]:min-h-32", value: request.body, onChange: (event) => {
                    setBody(event.target.value);
                    if (event.target.value !== '' && selectedContentType) {
                        setHeader('Content-Type', selectedContentType);
                    }
                } })] }));
}
